<div class="content">
  <!-- <h3>MIS PARADAS FAVORITAS</h3> -->

  <!-- <mat-card *ngFor="let x of favoriteStops" >
    <a class="item" [href]="x.url" >
      <mat-icon class="color-icon">check_circle</mat-icon>
      <div class="item-content">
        <h4 class="title">
          {{ x.stopName }}
        </h4>

        <h1
          class="badgeImp"
          *ngFor="let route of x?.routes"
          [style.background]="routeColor(route?.route_color)"
        >
          {{ route?.busName }}
        </h1>
      </div>

        <mat-icon class="color-icon location-icon">
          location_on
        </mat-icon>

      <mat-divider></mat-divider>
    </a>
  </mat-card> -->



        <div class="responsive-grid" >
          <mat-card style="grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));cursor: pointer;" *ngFor="let x of favoriteStops" (click)="navigateTo(x.url)">
            <mat-card-header>
                <h1 class="badgeImp" *ngFor="let route of x?.routes" [style.background]="routeColor(route?.route_color)">
                  {{ route?.busName }}
                </h1>
            </mat-card-header>

            <mat-divider></mat-divider>


            <div class="iconlocation">
              <mat-icon class="color-icon">
                location_on
              </mat-icon>
            </div>

            <div class="item" >
              <mat-card-content>
                {{ x.stopName }}
              </mat-card-content>
            </div>

          </mat-card>
        </div>








<!--
  <mat-card style="max-width: 400px;">
    <a class="item" *ngFor="let x of favoriteStops" [href]="x.url">
      <mat-card-header>
        <mat-card-title>
          {{x.busname}}
        </mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        {{ x.stopName }}
      </mat-card-content>
        <h1
          class="badge"
          *ngFor="let route of x?.routes"
          [style.background]="routeColor(route?.route_color)"
        >

        </h1>
        <mat-card-actions>
          <button>{{ route?.busName }}</button>
        </mat-card-actions>

      <mat-divider></mat-divider>
    </a>
  </mat-card> -->

  <h5 class="text-center" *ngIf="!favoriteStops.length">Actualmente no tienes paradas favoritas</h5>
</div>
